



























/* Created- 03 - Apr - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { PageContent, PageContentItem } from "../../Models/Components.model";
import { eParticaAction, ParticaEvent } from "../../Models/ParticaEvent";

@Component(
	{
		name: "ContentSelector"
	})
export default class ContentSelector extends Vue {
	@Prop() private content: PageContent; // your data
	@Prop() private width: number;
	@Prop({ default: "0" }) private selectedId: string;
	private viewbox(): string {
		return `0 0 ${this.content.width} ${this.content.height}`;
	}

	private clicked(item: PageContentItem) {
		this.$emit("partica-event", { action: eParticaAction.LEFT_MOUSE_CLICK, item } as ParticaEvent);
	}
	private rightclicked(item: PageContentItem, e: any) {
		this.$emit("partica-event", { action: eParticaAction.RIGHT_MOUSE_CLICK, item, sourceEvent: e } as ParticaEvent);
	}

	private getClass(item: PageContentItem): string {
		if (item.content === this.selectedId) {
			return item.class + " selected";
		}
		return item.class;
	}
}
